import React from 'react';

import type { ShareFeedItem as ShareFeedItemType } from '#src/app/pages/psf/share/pageContext';

import { ShareFeedItem } from './components/ShareFeedItem';
import { useShareFeed } from './hooks/useShareFeed';

const DEFAULT_INTERVAL_SECONDS = 3;

export const ShareFeed: React.FC<Props> = ({ items, intervalSeconds = DEFAULT_INTERVAL_SECONDS }) => {
	const scrollerRef = useShareFeed(intervalSeconds, items.length);
	const doubled = [...items, ...items];

	return (
		<div className="relative">
			<div
				ref={scrollerRef}
				className="ml-6 flex snap-x snap-proximity flex-row gap-3 overflow-x-hidden scroll-smooth whitespace-nowrap md:ml-10"
			>
				{doubled.map((item, index) => (
					<ShareFeedItem item={item} key={`${item.id}-${index}`} className="snap-start" />
				))}
			</div>
			<div
				aria-hidden
				className="pointer-events-none absolute top-0 h-full w-full bg-[linear-gradient(to_right,transparent_80%,var(--color-background-base))]"
			/>
		</div>
	);
};

type Props = Readonly<{
	intervalSeconds?: number;
	items: readonly ShareFeedItemType[];
}>;
